// Import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';
import 'swiper/css';


document.addEventListener('DOMContentLoaded', function () {
    
    const sliderElements = document.querySelectorAll('.gt-is-slider');
    initSwiper(sliderElements);
    

});

// Reinitialize on window resize
window.addEventListener('resize', function () {

    const sliderElements = document.querySelectorAll('.gt-is-slider');
    initSwiper(sliderElements);

});

window.addEventListener('gt_ws_thelis_updated', function () {

    const sliderElements = document.querySelectorAll('.gt-is-slider');
    initSwiper(sliderElements);
    
});

window.addEventListener('gt_ws_ctv_updated', function () {

    document.querySelectorAll('.swiper-wrapper > *').forEach(child => {
        child.classList.add('swiper-slide');
    });
    const sliderElements = document.querySelectorAll('.gt-is-slider');

    initSwiper(sliderElements);

});

let swiperInitInProgress = false;

function initSwiper(sliderElements) {

    if (swiperInitInProgress) return; // Prevent re-initializing if in progress

    swiperInitInProgress = true;

    if (!sliderElements.length) {
        swiperInitInProgress = false;
        return;
    }

    // Load CSS 
    loadCSS('/wp-content/themes/geektonic-fse/assets/js/gt-front/assets/css/swiper-bundle.min.css');
    loadCSS('/wp-content/themes/geektonic-fse/assets/js/gt-front/assets/css/gt-swiper-styles.css');

    let swipers = []; // To store all Swiper instances

    sliderElements.forEach((slider, index) => {
        if (!slider.originalClassName) slider.originalClassName = slider.className;

        if (window.innerWidth <= 1024 || !slider.classList.contains('gt-is-slider-mobile')) {
            if (!slider.classList.contains('swiper-initialized')) {
                setupSlider(slider, index, swipers);
            }
        } else {
            if (slider.classList.contains('swiper-initialized')) {
                destroySlider(slider, index, swipers);
            }
        }
    });

    swiperInitInProgress = false;

}

function setupSlider(slider, index, swipers) {
    // Add necessary classes and wrappers
    const additionalClasses = Array.from(slider.classList).filter(className => 
        className.startsWith('gt-ws-thelis-') || className.startsWith('gt-ws-ctv-')
    ).join(' ');

    slider.className = slider.classList.contains('gt-is-slider-mobile')
        ? `swiper gt-is-slider gt-is-slider-mobile ${additionalClasses}`
        : `swiper gt-is-slider ${additionalClasses}`;

    wrapSliderContent(slider);

    const config = getConfig(slider);


    // Gestion des controls
    if (config.controller && config.controller.control) {
        const controlEl = document.getElementById(config.controller.control);
        if (controlEl && controlEl.swiper) {
            config.controller = { control: controlEl.swiper }; // Connecte l'instance Swiper
        }
    }

    // Ajout pour détecter les sliders imbriqués
    const inCoverBlock = slider.closest('.gt-multiple-images-cover');
    if(inCoverBlock){
        const nestedSliderElement = inCoverBlock.querySelector('.wp-block-cover__inner-container .gt-is-slider');
        let nestedSwiper = null;
    
        if (nestedSliderElement) {
            wrapSliderContent(nestedSliderElement);
    
            const nestedConfig = getConfig(nestedSliderElement);
    
            // Initialize the nested slider
            nestedSwiper = new Swiper(nestedSliderElement, nestedConfig);
    
            // Synchronize the parent and nested sliders
            config.controller = { control: nestedSwiper };
            nestedConfig.controller = { control: swipers[index] };
        }
    }

    // Add navigation buttons
    let buttonNext = document.createElement('div');
    buttonNext.className = 'swiper-button-next';
    let buttonPrev = document.createElement('div');
    buttonPrev.className = 'swiper-button-prev';

    if (config.navigation) {
        if (config.navigation.nextEl === 'buttonNext' || config.navigation.nextEl === '.swiper-button-next') {
            slider.insertBefore(buttonNext, slider.firstChild);
        } else {
            buttonNext = config.navigation.nextEl;
        }
        if (config.navigation.prevEl === 'buttonPrev' || config.navigation.prevEl === '.swiper-button-prev') {
            slider.insertBefore(buttonPrev, slider.firstChild);
        } else {
            buttonPrev = config.navigation.prevEl;
        }
    }

    // Add pagination if necessary
    const pagination = document.createElement('div');
    pagination.className = 'swiper-pagination';
    if (config.pagination && config.pagination.el === '.swiper-pagination') {
        slider.appendChild(pagination);
    }

    // Update navigation elements in config
    if (config.navigation) {
        config.navigation.nextEl = buttonNext;
        config.navigation.prevEl = buttonPrev;
    }

    // Update pagination elements in config
    if (config.pagination && config.pagination.el === '.swiper-pagination') {
        config.pagination.el = pagination;
        config.pagination.clickable = true;
    }

    // Initialize Swiper
    const swiper = new Swiper(slider, config);

    // Mark the slider as initialized and save the instance
    slider.classList.add('swiper-initialized');
    swipers[index] = swiper;
}


function destroySlider(slider, index, swipers) {
    // Destroy Swiper instance
    if (swipers[index]) {
        swipers[index].destroy(true, true);
    }

    // Restore original classes and remove navigation buttons
    slider.classList.remove('swiper-initialized');
    slider.className = slider.originalClassName;

    const buttonNext = slider.querySelector('.swiper-button-next');
    const buttonPrev = slider.querySelector('.swiper-button-prev');
    if (buttonNext) buttonNext.remove();
    if (buttonPrev) buttonPrev.remove();
}

function wrapSliderContent(slider) {
    if (slider.children.length === 1) {
        const wrapper = slider.firstElementChild;
        wrapper.classList = '';
        wrapper.classList.add('swiper-wrapper');
        Array.from(wrapper.children).forEach(child => {
            if (!child.classList.contains('swiper-wrapper')) {
                child.classList.add('swiper-slide');
            }
        });
    } else {
        const wrapper = document.createElement('div');
        wrapper.classList.add('swiper-wrapper');
        Array.from(slider.children).forEach(child => {
            if (!child.classList.contains('swiper-wrapper')) {
                child.classList.add('swiper-slide');
            }
            wrapper.appendChild(child);
        });
        slider.innerHTML = '';
        slider.appendChild(wrapper);
    }
}

function getConfig(slider) {
    const defaultConfig = {
        speed: 400,
        spaceBetween: 16,
        slidesPerView: 3,
        createElements: true,
        loop: true,
        freemode: true,
        pagination: {
            el: '.swiper-pagination',
            dynamicBullets: true,
            clickable: true
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        breakpoints: {
            0: {
                slidesPerView: 1
            },
            380: {
                slidesPerView: 2
            },
            1024: {
                slidesPerView: 3
            }
        }
    };

    if (slider.dataset.swiper) {
        const newConfig = { ...defaultConfig, ...JSON.parse(slider.dataset.swiper) };
        return newConfig;
    } else {
        return defaultConfig;
    }
}


function loadCSS(href) {
    if (!document.querySelector(`link[href="${href}"]`)) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        link.type = 'text/css';
        document.head.appendChild(link);
    }
}
